import {Box, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

interface WidgetCardProps extends TestIdProps {
  children: ReactNode;
}

export function WidgetCard(props: WidgetCardProps) {
  return (
    <Box
      backgroundColor="palettes.neutral.10.100"
      borderRadius="medium"
      padding={4}
      data-testid={suffixTestId('widgetCard', props)}
    >
      <VStack spacing={4}>{props.children}</VStack>
    </Box>
  );
}
